import React from 'react';

import newsApi from '/src/apis/newsApi';
import Slider from '/src/widgets/Slider';
import AmplitudeHelperClass from '/src/utilities/amplitudeHelper';
import { getItemWebUrl } from '/src/utilities/helpers';



const amplitudeHelper = new AmplitudeHelperClass();

export default class Mentions extends Slider {

    componentDidMount() {
        let id = this.props.id;
        newsApi.getMentions(id).then((response) => {
            if (response) {
                const mentions = response.filter((mention) => mention.entity_data);
                this.setState({ item: mentions });
                this.initializeSlider();
                this.moveSlider();
            }
        });
    }

    segTrack = (profile) => {
        amplitudeHelper.trackEvent('Clicked Mention Profile', {
            button_clicked: profile
        });
    }

    handleprofileURL = (entity) => {
        const entityType = entity.entity_data.type;
        const entityCode = entity.entity_data.code;
        const entityId   = entity.entity_id;

        const formatedEntityType = entityType.toLowerCase() + "s"
        const URL = getItemWebUrl(formatedEntityType, entityId, entityCode);
        const profileURL = `/${URL}`;
        return profileURL;
    }

    handleEntityType = (entity) => {
        const { entityType } = entity;
        if (entityType === "USER") {
            return "Person"
        }
        const capitalizedFirstLetter = entityType[0] + entityType.slice(1).toLowerCase()
        return capitalizedFirstLetter
    }

    handleLogo = (entity) => {
        const entityLogo = entity.entity_data.logo;
        if (entityLogo) {
            return `url('${encodeURI(entityLogo)}')`
        }
        return null
    }

    render() {

        const { item, limit, itemSlider, fadeClass, slider } = this.state;
        const { displayCount } = this.props;
        const showSliderButtons = item.length > displayCount;

        if (item.length > 0 && slider) {
            return (
                <div className="mentions-container">
                    <div className="db-header mb-0">
                        <p className="heading-1">Mentions</p>
                        {showSliderButtons &&
                            <div className="d-flex align-items-top mt-0">

                                {/* back button */}
                                {slider.start > 0 ?
                                    <div className="slider-btn" onClick={() => this.moveSlider("prev")}>
                                        <i className="fas fa-chevron-left"></i>
                                    </div>
                                    :
                                    // disabled
                                    <div className="slider-btn">
                                        <i className="fas fa-chevron-left disabled"></i>
                                    </div>
                                }

                                {/* next button */}
                                {slider.end < (limit - 1) ?
                                    <div className="slider-btn" onClick={() => this.moveSlider("next")}>
                                        <i className="fas fa-chevron-right"></i>
                                    </div>
                                    :
                                    // disabled
                                    <div className="slider-btn">
                                        <i className="fas fa-chevron-right disabled"></i>
                                    </div>
                                }

                            </div>
                        }
                    </div>
                    <div className="row mentions-grid">
                        {itemSlider.map((entity, i) => {
                            return (
                                <div key={i} className={`mt-0 mentions-box ${fadeClass}`}>
                                    <div className="slider-row border-none h-auto">
                                        <a
                                            href={this.handleprofileURL(entity)}
                                            onClick={() => this.segTrack(entity.entity_id)}
                                            key={entity.id}
                                            className="mentions-item"
                                            aria-label={entity.entity_data.name[0]}
                                        >
                                            <div className="image d-flex justify-content-center align-items-center" style={{ background: this.handleLogo(entity) }} >
                                                {!this.handleLogo(entity) &&
                                                    <h2>{entity.entity_data.name[0]}</h2>
                                                }
                                            </div>
                                        </a>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </div>
            );
        } else {
            return (null);
        }

    }

}